export default "data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAADwAQCdASoFAAYAAgA0JZgCdLoAAwhAXqAA/uiUfKFWsCXzSjR4SFE1zAIozLPXntPVL7iC+HsohslAAAA="